import { StatusPill } from 'component-library';
import { CalculateMinutesToDays } from '../../../../helpers/Custom';
import { EventLog, System } from '../../../../models/ApiModels';
import LogEventTimeData from './EventLogsTimeUserData';

interface Props {
  system?: System;
  event: EventLog;
  isUsersLoading: boolean;
  user: string;
  isHumphreeUser: boolean;
}

export default function LogFunctionTrialCreated(props: Props) {
  const days = CalculateMinutesToDays(parseInt(props.event.arguments[0])).toString() + ' days';
  return (
    <div className='flex lg:flex-nowrap flex-wrap justify-between items-center border-b border-gray-10'>
      <div className='py-8 flex flex-wrap flex-row items-center gap-2'>
        <span className=' flex prose-paragraphBase text-gray-100'>Function trial created for </span>
        <StatusPill color='Light Pink' text={days} />
      </div>
      <LogEventTimeData
        event={props.event}
        isUsersLoading={props.isUsersLoading}
        user={props.user}
        isHumphreeUser={props.isHumphreeUser}
      />
    </div>
  );
}
